import { PATH } from './constants/router'
import AutomatedTrafficFineNotificationAuthentication from './page/AutoTrafficFineNotificationAuthentication'
import AutomatedTrafficFineNotificationIntroduce from './page/AutoTrafficFineNotificationIntroduce'
import AutomatedTrafficFineNotificationPayment from './page/AutoTrafficFineNotificationPayment'
import AutomatedTrafficFineNotificationServices from './page/AutoTrafficFineNotificationServices'
import AutomatedTrafficFineNotificationSuccess from './page/AutoTrafficFineNotificationSuccess'
import AutoTrafficFineNotificationVehicles from './page/AutoTrafficFineNotificationVehicles'
import TrafficFineCheckResult from './page/AutoTrafficFineNotificationCheckResult'
import AutoTrafficFineNotificationLookup from './page/AutoTrafficFineNotificationLookup'
import AutoTrafficFineNotificationPackageInfo from './page/AutoTrafficFineNotificationPackageInfo'
import AutoTrafficFineNotificationPhoneAuth from './page/AutoTrafficFineNotificationPhoneAuth'
import AutoTrafficFineNotificationPaymentSuccess from './page/AutoTrafficFineNotificationPaymentSuccess'
import AutoTrafficFineNotificationRedirectHandler from './page/AutoTrafficFineNotificationRedirectHandler'
import TaxCDSIntroduce from './page/TaxCDSIntroduce'
import TaxCDSSmartAssistantInfo from './page/TaxCDSSmartAssistantInfo'
import TrafficFineFAQ from './page/TrafficFineFAQ'
import { DEFAULT_HOME_PAGE, getDefaultHomePage } from './constants/homePage'


const HOME_PAGE_COMPONENT = {
  [DEFAULT_HOME_PAGE.TRAFFIC_FINE_LOOKUP]: AutoTrafficFineNotificationLookup,
  [DEFAULT_HOME_PAGE.TAX_CDS_INTRODUCE]: TaxCDSIntroduce
}

const DEFAULT_HOME_COMPONENT = HOME_PAGE_COMPONENT[getDefaultHomePage()] || AutoTrafficFineNotificationLookup

export const ROUTERS = {
  home: {
    path: PATH.HOME,
    component: DEFAULT_HOME_COMPONENT
  },

  taxCdsIntroduce: {
    path: PATH.TAX_CDS_INTRODUCE,
    component: TaxCDSIntroduce
  },

  taxCdsSmartAssistant: {
    path: PATH.TAX_CDS_SMART_ASSISTANT,
    component: AutomatedTrafficFineNotificationServices
  },
  taxCdsSmartAssistantInfo: {
    path: PATH.TAX_CDS_SMART_ASSISTANT_INFO,
    component: TaxCDSSmartAssistantInfo
  },
  automatedTrafficFineNotificationServices: {
    path: PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_SERVICES,
    component: AutomatedTrafficFineNotificationServices
  },
  trafficFineLookup: {
    path: PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_LOOKUP,
    component: AutoTrafficFineNotificationLookup
  },
  trafficFineCheckResult: {
    path: PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_CHECK_RESULT,
    component: TrafficFineCheckResult
  },
  trafficFinePackageInfo: {
    path: PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_PACKAGE_INFO,
    component: AutoTrafficFineNotificationPackageInfo
  },
  automatedTrafficFineNotificationVehicles: {
    path: PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_VEHICLES,
    component: AutoTrafficFineNotificationVehicles
  },
  automatedTrafficFineNotificationPayment: {
    path: PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_PAYMENT,
    component: AutomatedTrafficFineNotificationPayment
  },
  automatedTrafficFineNotificationIntroduce: {
    path: PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_INTRODUCE,
    component: AutomatedTrafficFineNotificationIntroduce
  },
  automatedTrafficFineNotificationSuccess: {
    path: PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_SUCCESS,
    component: AutomatedTrafficFineNotificationSuccess
  },
  autoTrafficFineNotificationPaymentSuccess: {
    path: PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_PAYMENT_SUCCESS,
    component: AutoTrafficFineNotificationPaymentSuccess
  },
  autoTrafficFineNotificationRedirectHandler: {
    path: PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_REDIRECT_HANDLER,
    component: AutoTrafficFineNotificationRedirectHandler
  },
  automatedTrafficFineNotificationAuthentication: {
    path: PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_AUTHENTICATION,
    component: AutomatedTrafficFineNotificationAuthentication
  },
  autoTrafficFineNotificationPhoneAuth: {
    path: PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_PHONE_AUTH,
    component: AutoTrafficFineNotificationPhoneAuth
  },
  trafficFineFAQ: {
    path: PATH.TRAFFIC_FINE_FAQ,
    component: TrafficFineFAQ
  }
}